import type {
    IRelayGroupMetadata,
    IRelayGroupResponse,
} from '@experiences/interfaces';
import { ensureZSuffix } from '@experiences/util';

export function mapRelayGroupCollection(originalResponse: IRelayGroupResponse): IRelayGroupResponse {
    const results: IRelayGroupMetadata[] = originalResponse.results.map(mapRelayGroup);
    return {
        totalCount: originalResponse.totalCount,
        results,
    };
}

function mapRelayGroup(relayGroup: IRelayGroupMetadata): IRelayGroupMetadata {
    return {
        ...relayGroup,
        ...(relayGroup.updatedAt && { updatedAt: ensureZSuffix(relayGroup.updatedAt) as Date }),
    };
}
